import React from "react";
import { Link } from "react-router";
import { closeParentDetails } from "./reactBootstrapShim";

/* In-app navigation entry for the daisyUI <details> dropdowns (shim
   DropdownButton or plain markup): a real router <Link> so middle-click /
   ctrl-click / open-in-new-tab work, closing the menu on plain click. */
export function MenuLink({
  to,
  children,
  onClick,
}: {
  to: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    closeParentDetails(e);
    onClick?.(e);
  };
  return (
    <li role="presentation">
      <Link role="menuitem" to={to} onClick={handleClick}>
        {children}
      </Link>
    </li>
  );
}
